import { FC, useMemo } from 'react';
import UploadValidation from '../../components/UploadValidation/UploadValidation';
import UploadValidationSmall from '../../components/UploadValidationSmall/UploadValidationSmall';
import { uploadAllowedFileTypes, uploadMaxFileSize } from '../../helpers';
import { IUploadProps } from '../../types';
import './style.scss';

type TProps = Pick<IUploadProps, 'smallValidationBlock' | 'maxFileSize' | 'allowedFileTypes'>;

const UploadValidations: FC<TProps> = ({ smallValidationBlock, ...props }: TProps): JSX.Element => {
  const maxFileSize = useMemo((): string | null => uploadMaxFileSize(props.maxFileSize), [props.maxFileSize]);

  const allowedFileTypes = useMemo((): string[] => uploadAllowedFileTypes(props.allowedFileTypes), [props.allowedFileTypes]);

  return smallValidationBlock ? (
    <UploadValidationSmall maxFileSize={maxFileSize} allowedFileTypes={allowedFileTypes} />
  ) : (
    <UploadValidation maxFileSize={maxFileSize} allowedFileTypes={allowedFileTypes} />
  );
};

export default UploadValidations;
